/**
 * Document sections that copy the tax document series when the operator picks it, so a deposit
 * method only has to be configured once.
 */
export const PROPAGATED_DOC_SERIES_SECTIONS = [
  'taxDocumentEu',
  'taxDocumentOutsideEu',
  'taxDocumentCorrection',
  'taxDocumentCorrectionEu',
  'taxDocumentCorrectionOutsideEu',
] as const;
